module.exports = __webpack_public_path__ + "img/sign-up_hero-img.36583007.png";